export default "__VITE_ASSET__a59a2822__"